var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3560_29752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3560_29752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0652 14.3589C10.2355 14.3589 10.3805 14.2988 10.5002 14.1785C10.6198 14.0582 10.6796 13.9129 10.6796 13.7426C10.6796 13.5723 10.6195 13.4273 10.4993 13.3076C10.379 13.188 10.2337 13.1281 10.0634 13.1281C9.89302 13.1281 9.74802 13.1883 9.62837 13.3085C9.5087 13.4288 9.44887 13.5741 9.44887 13.7444C9.44887 13.9148 9.509 14.0598 9.62927 14.1794C9.74953 14.2991 9.89483 14.3589 10.0652 14.3589ZM9.63477 11.6201H10.4184C10.4398 11.2024 10.501 10.9046 10.6019 10.7267C10.7029 10.5488 10.8629 10.3466 11.0819 10.1201C11.5787 9.6372 11.9075 9.24511 12.0683 8.94384C12.2291 8.64254 12.3095 8.32616 12.3095 7.99469C12.3095 7.3518 12.103 6.80413 11.6901 6.35167C11.2772 5.89921 10.7416 5.67298 10.0835 5.67298C9.56747 5.67298 9.08643 5.81508 8.64039 6.09927C8.19434 6.38347 7.86714 6.76488 7.65881 7.2435L8.40402 7.58165C8.59311 7.13934 8.82575 6.83993 9.10193 6.68342C9.3781 6.52689 9.68072 6.44863 10.0098 6.44863C10.4948 6.44863 10.8757 6.58645 11.1524 6.86211C11.4291 7.13775 11.5675 7.48817 11.5675 7.91338C11.5675 8.2435 11.4652 8.52555 11.2606 8.75952C11.056 8.99351 10.8217 9.23924 10.5579 9.49671C10.1999 9.845 9.95663 10.1775 9.82789 10.4943C9.69914 10.8111 9.63477 11.1863 9.63477 11.6201ZM10.003 17.1666C9.02139 17.1666 8.09493 16.9802 7.22358 16.6074C6.35223 16.2347 5.58928 15.7213 4.93473 15.0674C4.28018 14.4135 3.76634 13.6513 3.3932 12.7808C3.02007 11.9103 2.8335 10.9843 2.8335 10.0027C2.8335 9.00725 3.01988 8.07732 3.39264 7.21292C3.76542 6.34852 4.27877 5.58904 4.93268 4.93448C5.5866 4.27994 6.3488 3.7661 7.21929 3.39296C8.08979 3.01982 9.01582 2.83325 9.99737 2.83325C10.9928 2.83325 11.9228 3.01963 12.7872 3.3924C13.6516 3.76518 14.411 4.27852 15.0656 4.93244C15.7201 5.58636 16.234 6.34509 16.6071 7.20863C16.9803 8.07218 17.1668 9.00168 17.1668 9.99713C17.1668 10.9787 16.9804 11.9052 16.6077 12.7765C16.2349 13.6479 15.7216 14.4108 15.0676 15.0654C14.4137 15.7199 13.655 16.2337 12.7915 16.6069C11.9279 16.98 10.9984 17.1666 10.003 17.1666Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.09225dab7a533905d3280a597a9d9141.svg";
export { ForwardRef as ReactComponent };